<div class="modal-header card-header">
    <div class="col-10">
        <span class="text-blue text-125">Jugadores duplicados</span><br>
        <span class="text-grey-m1 text-90">
            Mismo C.I., mismo nombre o nombre parecido: es el mismo jugador. Se conserva el que tiene foto y está en un campeonato activo.
        </span>
    </div>
    <div class="col-2 text-right">
        <button class="btn btn-danger" type="button" (click)="cerrarComponente()">
            <i class="fa fa-times red2 text-110"></i>
        </button>
    </div>
</div>
<div class="modal-body card-body">
    <div *ngIf="cargando" class="text-center text-grey p-3">Buscando duplicados...</div>

    <div *ngIf="!cargando">
        <div *ngIf="resultado" class="alert alert-success py-2">
            <i class="fa fa-check-circle mr-1"></i> {{resultado.mensaje}}
        </div>

        <div *ngIf="grupos.length==0" class="text-center text-success p-3">
            <i class="fa fa-check-circle mr-1"></i> No hay jugadores duplicados.
        </div>

        <div *ngIf="grupos.length>0" class="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <div class="text-110 mb-1">
                <b>{{obtenerGruposMarcados().length}}</b> de {{grupos.length}} jugadores marcados para unificar
                (<b>{{contarRegistrosSobrantes()}}</b> registros repetidos)
            </div>
            <button class="btn btn-success btn-lg" [disabled]="obtenerGruposMarcados().length==0" (click)="unificarTodo()">
                <i class="fa fa-compress-arrows-alt mr-1"></i> Unificar todo
            </button>
        </div>

        <div *ngIf="grupos.length>0">
            <div class="row mb-2">
                <div class="col-12 col-md-7 mb-1">
                    <input type="text" class="form-control" [(ngModel)]="texto_busqueda" placeholder="Buscar por nombre o C.I. para ver cómo quedará" />
                </div>
                <div class="col-12 col-md-5 mb-1 pt-2">
                    <label>
                        <input type="checkbox" class="align-middle" [(ngModel)]="solo_revisar" />
                        Ver solo los que conviene revisar ({{contarParaRevisar()}})
                    </label>
                </div>
            </div>
            <div class="text-grey-d1 text-90 mb-2">
                Desmarque los grupos que no son la misma persona; esos no se tocan.
            </div>
            <div class="table-responsive">
                <table class="table table-sm table-bordered mb-3">
                    <thead>
                        <tr class="bgc-primary-d1 text-white text-90">
                            <th class="text-center">Unificar</th>
                            <th>Se conserva</th>
                            <th>Se une y se quita</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let grupo of obtenerGruposFiltrados().slice(0,200)" [ngClass]="{'text-grey-l1':!grupo.unificar}">
                            <td class="text-center align-middle">
                                <input type="checkbox" [(ngModel)]="grupo.unificar" />
                            </td>
                            <td [ngClass]="{'fila-principal':grupo.unificar}">
                                <div class="d-flex align-items-center">
                                    <img class="foto-jugador mr-2" src="{{rest_server+grupo.jugadores[0].imagen}}" />
                                    <div>
                                        {{grupo.jugadores[0].nombre_completo}}<br>
                                        <small>C.I. {{grupo.ci_final || 'sin C.I.'}}</small>
                                        <small *ngIf="grupo.ci_final && !grupo.jugadores[0].ci" class="text-success ml-1">(se toma del repetido)</small>
                                        <span *ngIf="grupo.jugadores[0].en_campeonato_activo" class="badge badge-success ml-1">campeonato activo</span>
                                        <span *ngIf="grupo.por_parecido" class="badge badge-warning ml-1" title="Incluye jugadores sin C.I. unidos por nombre parecido">nombre parecido</span>
                                        <span *ngIf="grupo.otro_club" class="badge badge-danger ml-1" title="Une registros de clubes distintos">otro club</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div *ngFor="let jugador of grupo.jugadores.slice(1)" class="text-90">
                                    {{jugador.nombre_completo}} <small class="text-grey">(C.I. {{jugador.ci || 'sin C.I.'}})</small>
                                    <div class="text-grey text-85">{{jugador.torneos.join(' | ')}}</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="obtenerGruposFiltrados().length>200" class="text-grey text-90 mb-3">
                    Se muestran 200 de {{obtenerGruposFiltrados().length}}; use el buscador para ver uno en particular.
                </div>
            </div>
        </div>

        <div *ngIf="omitidos.length>0">
            <div class="text-warning-d2 text-110 mb-1">
                <i class="fa fa-exclamation-triangle mr-1"></i> {{omitidos.length}} registros no se unifican (se dejan como están)
            </div>
            <table class="table table-sm table-bordered">
                <tbody>
                    <tr *ngFor="let omitido of omitidos" class="text-90">
                        <td>{{omitido.jugador.nombre_completo}} <small class="text-grey">({{omitido.jugador.ci || 'sin C.I.'}})</small></td>
                        <td>{{omitido.motivo}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
